import HighlightText from '~/components/shared/HighlightText';
import {
  SearchHeader,
  SearchQuery,
  SearchFooter,
  DiscardSelectionDialog,
} from '~/components/shared/Modals/SearchParts';
import React, {useState, useCallback, useRef, useEffect} from 'react';
import {View, ActivityIndicator, ScrollView} from 'react-native';
import {Divider} from 'react-native-paper';
import debounce from 'lodash/debounce';
import sy from '~/styles';
import {Pressable, Text, Modal, Checkbox} from '~/components/controls';
import Format from '~/lib/format';
import PropTypes from 'prop-types';
const SearchWorkModal = ({
  works,
  visible,
  onPrefixChange,
  onAdd,
  onDismiss,
}) => {
  const [prefix, setPrefix] = useState('');
  const [selectedWorks, setSelectedWorks] = useState([]);
  const [searching, setSearching] = useState(false);
  const [results, setResults] = useState([]);
  const [highlightSearchText, setHighlightSearchText] = useState('');
  const [showCancelAddDialog, setShowCancelAddDialog] = useState(false);
  const searchTextRef = useRef(null);
  useEffect(() => {
    setTimeout(() => searchTextRef.current.focus(), 100);
  }, []);
  const onClose = () => {
    if (selectedWorks.length) {
      setShowCancelAddDialog(true);
    } else {
      onDismiss();
    }
  };
  const onSearchWork = useCallback(
    debounce(async (value) => {
      if (value.length < 3) {
        setResults([]);
        return;
      }
      setSearching(true);
      try {
        const {result, success} = await onPrefixChange(value);
        if (searchTextRef.current?.value === value && success) {
          setResults(result);
          return;
        }
      } finally {
        setSearching(false);
      }
      setResults([]);
    }, 500),
    [onPrefixChange],
  );
  return (
    <>
      <Modal visible={visible} onDismiss={onDismiss}>
        <SearchHeader
          title="TecRMI taak toevoegen"
          onClose={onClose}
          closeStyle={[sy['p-4']]}
        />
        <SearchQuery
          prefix={prefix}
          searchTextRef={searchTextRef}
          onChangeText={(value) => {
            onSearchWork.cancel();
            onSearchWork(value);
            setHighlightSearchText(value);
            setPrefix(value);
          }}
        />
        <Divider style={sy['bg-gray88']} />
        <ScrollView style={[sy['bg-gray95']]}>
          {searching ? (
            <View style={[sy['p-4']]}>
              <ActivityIndicator size="large" color="#231fda" />
            </View>
          ) : (
            results.map((result) => (
              <View
                key={result.work_id}
                style={[sy['bg-white'], sy['flex-row'], sy['items-center']]}>
                <Pressable
                  style={[sy['p-4'], sy['pr-8']]}
                  disabled={works.some(
                    ({work_id}) => work_id === result.work_id,
                  )}
                  onPress={() => {
                    if (
                      selectedWorks.some(
                        (item) => item.work_id === result.work_id,
                      )
                    ) {
                      setSelectedWorks(
                        selectedWorks.filter(
                          (item) => item.work_id !== result.work_id,
                        ),
                      );
                    } else {
                      setSelectedWorks([...selectedWorks, result]);
                    }
                  }}>
                  <Checkbox
                    style={{
                      width: 'auto',
                    }}
                    disabled={works.some(
                      ({work_id}) => work_id === result.work_id,
                    )}
                    checked={[...works, ...selectedWorks].some(
                      (item) => item.work_id === result.work_id,
                    )}
                  />
                </Pressable>
                <View
                  style={[
                    sy['flex-row'],
                    sy['py-4'],
                    sy['border-b'],
                    sy['border-lightgray'],
                    sy['flex-1'],
                    sy['pr-4'],
                    sy['gap-4'],
                  ]}>
                  <View style={[sy['flex-1']]}>
                    <View
                      style={{
                        display: 'inline',
                      }}>
                      <HighlightText
                        text={result.work_text}
                        highlight={highlightSearchText}
                      />
                    </View>
                    {result.qualifier && result.qualifier !== 'Standaard' && (
                      <Text style={[sy.small, sy['text-gray']]}>
                        {result.qualifier}
                      </Text>
                    )}
                    {result.add_text && result.add_text !== 'Standaard' && (
                      <Text style={[sy.small, sy['text-gray']]}>
                        {result.add_text}
                      </Text>
                    )}
                  </View>
                  <View>
                    <Text>{Format.number(result.work_time, 2)}&nbsp;u</Text>
                  </View>
                </View>
              </View>
            ))
          )}
        </ScrollView>
        <Divider style={sy['bg-gray88']} />
        <SearchFooter selection={selectedWorks} onAdd={onAdd} />
      </Modal>
      <DiscardSelectionDialog
        showCancelAddDialog={showCancelAddDialog}
        setShowCancelAddDialog={setShowCancelAddDialog}
        onDismiss={onDismiss}
      />
    </>
  );
};
SearchWorkModal.propTypes = {
  works: PropTypes.any,
  visible: PropTypes.any,
  onPrefixChange: PropTypes.any,
  onAdd: PropTypes.any,
  onDismiss: PropTypes.any,
};
export default SearchWorkModal;
